import { useState, useEffect } from 'react';
import style from './PlatformsAnnualService.module.scss';
import api from 'helpers/api';
import Loader from "components/miscellaneous/Loader/Loader";
import AliceCarousel from "react-alice-carousel";
import 'react-alice-carousel/lib/alice-carousel.css';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { FaChartPie } from 'react-icons/fa'
import { MdDone } from 'react-icons/md'
import HasPermission from '../../../../helpers/permissions/HasPermission';

const PlatformsAnnualService = () => {
    const [ platforms, setPlatforms ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const [ initiated, setInitiated ] = useState(false);
    const [ markedPlatform, setMarkedPlatform ] = useState(null);

    const loadData = async () => {
        try {
            if (!initiated) {
                setLoading(true);
            }

            const res = await api.get('dashboard/platforms/service');
            if (res.data && res.data.success) {
                setPlatforms(res.data.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
            setInitiated(true);
        }
    }

    const handleMarkAsDone = async (platform) => {
        try {
            await api.patch(`platform/${platform.id}/service`);
        } catch (error) {
            console.error(error);
        } finally {
            setMarkedPlatform(null);
        }
    }

    useEffect(() => {
        if (initiated === false) {
            loadData()
        }
    }, []);

    useEffect(() => {
        if (markedPlatform) {
            handleMarkAsDone(markedPlatform).then(() => {
                loadData();
            });
        }
    }, [ markedPlatform ]);

    return (<div className={ style.container }>
        { loading && <Loader color={ '#ddd' } /> }
        { initiated && (
            platforms.length > 0 ? <AliceCarousel
                mouseTracking
                items={ platforms.map((platform, i) => {
                    const isLoading = markedPlatform !== null && markedPlatform.id === platform.id;
                    return (
                        <div className={ style.platformCard } key={ i }>
                            { isLoading && <div className={ style.platformLoader }><Loader color={ '#ddd' } /></div> }
                            <img src={ platform.image } alt={ platform.name } />
                            <div className={ style.platformInfo }>
                                <Link to={ `/equipment/platform/${platform.id}` }>
                                    <a href={ `/equipment/platform/${platform.id}` }>
                                        <div className={ style.platformName }>{ platform.machine_id }</div>
                                    </a>
                                </Link>
                                <div className={ style.clinicName }>{ platform.clinic_name }</div>
                                <div className={ style.lastConnected }>
                                    { platform.last_connected_at ? <>Last active { moment(platform.last_connected_at).fromNow() }</> : <>Not Active</> }
                                </div>
                                <HasPermission permission={ "platform.edit" }>
                                    <button onClick={ (e) => {
                                        e.preventDefault();
                                        setMarkedPlatform(platform);
                                    } }>
                                        <MdDone /> Mark as Done
                                    </button>
                                </HasPermission>
                            </div>
                        </div>
                    )
                }) }
                responsive={ {
                    1440: { items: 5 },
                    1200: { items: 4 },
                    992: { items: 3 },
                    768: { items: 2 },
                    0: { items: 1 }
                } }
                autoWidth={ false }
                disableButtonsControls={ false }
                disableDotsControls={ true }
                keyboardNavigation={ true }
            /> : <div className={ style.noData }>
                <FaChartPie />
                No data
            </div>
        ) }

    </div>)
}

export default PlatformsAnnualService;
